var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{staticClass:"prop-table mb-2"},[_c('tr',[_c('th',[_vm._v("Participant amount")]),_c('td',[_vm._v(_vm._s(_vm._f("getFormattedNumber")(_vm.stat.participantAmount)))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }